import { render, staticRenderFns } from "./SpecialistItem.vue?vue&type=template&id=37e49770&scoped=true"
import script from "./SpecialistItem.vue?vue&type=script&lang=js"
export * from "./SpecialistItem.vue?vue&type=script&lang=js"
import style0 from "./SpecialistItem.vue?vue&type=style&index=0&id=37e49770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e49770",
  null
  
)

export default component.exports